import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { ExpandedTooltip, Icon, toast } from '@livable/saas-react-components';
import { InputAdornment, IconButton, TextField, Button } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useStore } from 'src/stores';
import useStyles from './styles';
import { FilePreviewModal } from '../FilePreviewModal';
import { RemoveFileModal } from '../RemoveFileModal';
export default function FileUploader(_ref) {
  let billSettingsAccepted = _ref.billSettingsAccepted,
    callback = _ref.callback,
    disabled = _ref.disabled,
    fileName = _ref.fileName,
    icon = _ref.icon,
    isFileUploadingAccepted = _ref.isFileUploadingAccepted,
    isUtilityForm = _ref.isUtilityForm,
    label = _ref.label,
    setModalIsOpen = _ref.setModalIsOpen,
    tooltipText = _ref.tooltipText,
    uploadStartedCallback = _ref.uploadStartedCallback,
    filePreviewLink = _ref.filePreviewLink,
    isPreviewForm = _ref.isPreviewForm,
    validator = _ref.validator,
    isDisabledParent = _ref.isDisabledParent,
    calculateFormFromModal = _ref.calculateFormFromModal,
    selectedCycleStartDate = _ref.selectedCycleStartDate,
    utility = _ref.utility;
  const classes = useStyles();
  const fileInputRef = useRef();
  const store = useStore();
  const _useState = useState(fileName || ''),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFilePreviewModalOpen = _useState4[0],
    setIsFilePreviewModalOpen = _useState4[1];
  const _useState5 = useState(fileName ? true : false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDeleteButton = _useState6[0],
    setIsDeleteButton = _useState6[1];
  useEffect(() => {
    setValue(fileName);
    setIsDeleteButton(fileName ? true : false);
  }, [fileName]);
  const handleFileUpload = async e => {
    if (e.target.files.length > 0) {
      var _uploadedFileResult;
      if (e.target.files[0].size >= 1048576 * 100) {
        // NOTE: base is 1MB * 100
        toast('error', {
          body: ['File is too large, maximum file size is 100 MB']
        });
        return;
      }
      uploadStartedCallback();
      setValue(e.target.files[0].name);
      let uploadedFileResult;
      if (store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled) {
        uploadedFileResult = await store.files.uploadFileViaPresignedUrlExperimentAsync.run({
          file: e.target.files[0],
          createdBy: store.account.userProfile.id
        });
      } else {
        uploadedFileResult = await store.files.uploadFileAsync.run({
          file: e.target.files[0]
        });
      }

      // const uploadedFileResult = await store.files.uploadFileAsync.run({
      //   file: e.target.files[0],
      // });

      if ((_uploadedFileResult = uploadedFileResult) !== null && _uploadedFileResult !== void 0 && _uploadedFileResult.isSuccessful) {
        const fileId = uploadedFileResult.response;
        // NOTE: after successfully load file id would be received and it should be assigned to right place

        callback(fileId);
      } else {
        callback(uploadedFileResult);
      }
    }
  };
  const handleClick = e => {
    if (isUtilityForm && !isFileUploadingAccepted && !billSettingsAccepted) {
      e.preventDefault();
      setModalIsOpen(true);
    }
  };
  const handleDelete = () => {
    setValue('');
    setIsDeleteButton(false);
    fileInputRef.current.value = null;
    if (typeof callback === 'function') {
      callback(null);
    }
  };
  useEffect(() => {
    if (isUtilityForm && !isFileUploadingAccepted && billSettingsAccepted) {
      fileInputRef.current.click();
      store.files.setFileUploadingAccepted();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billSettingsAccepted]);
  const adornments = {
    endAdornment: isUtilityForm ? /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end",
      type: "infoTooltip"
    }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
      type: "grey",
      title: tooltipText,
      placement: "top"
    }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
      state: "info",
      type: "question"
    })))) : null
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.fileUploaderWrapper
  }, fileName === '' ? /*#__PURE__*/React.createElement("div", {
    className: classes.startIcon
  }, icon || /*#__PURE__*/React.createElement(Icon, {
    type: "file-add"
  })) : /*#__PURE__*/React.createElement("div", {
    className: classes.startPreviewIcon
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: 'Preview file'
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: () => {
      setIsFilePreviewModalOpen(!isFilePreviewModalOpen);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "link"
  })))), /*#__PURE__*/React.createElement(TextField, {
    disabled: disabled,
    fullWidth: true,
    className: isDeleteButton ? classes.fileInputWithDelete : classes.fileInput,
    inputProps: {
      style: {
        opacity: '0',
        cursor: 'pointer'
      }
    },
    InputLabelProps: {
      shrink: !!value
    },
    inputRef: fileInputRef,
    InputProps: adornments,
    label: label,
    onChange: handleFileUpload,
    onClick: handleClick,
    type: "file"
  }), value && /*#__PURE__*/React.createElement("div", {
    className: classes.fileName
  }, value), isDeleteButton && /*#__PURE__*/React.createElement(RemoveFileModal, {
    callback: handleDelete,
    trigger: /*#__PURE__*/React.createElement(Button, {
      state: "white",
      variant: "actionIcon",
      disabled: disabled,
      className: classes.deleteButton,
      'custom-attribute': '334-FileUploader'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "delete"
    }))
  }), /*#__PURE__*/React.createElement(FilePreviewModal, {
    docUri: filePreviewLink,
    fileName: fileName,
    isOpen: isFilePreviewModalOpen,
    handleClose: () => setIsFilePreviewModalOpen(!isFilePreviewModalOpen),
    handleOpen: () => setIsFilePreviewModalOpen(!isFilePreviewModalOpen),
    validator: validator,
    isPreviewForm: isPreviewForm,
    isDisabledParent: isDisabledParent,
    calculateFormFromModal: calculateFormFromModal,
    selectedCycleStartDate: selectedCycleStartDate,
    utility: utility
  }));
}